import { Button } from "react-bootstrap";

export default function ButtonMain({ children, onClick, style, disabled = false }) {
    const buttonStyle = { 
        backgroundColor: disabled ? '#52525C' : '#8E51FF', 
        fontWeight: 'bold', 
        padding: '10px 20px',
        cursor: disabled ? 'not-allowed' : 'pointer'
    }

    return (
        <Button 
            onClick={onClick} 
            style={{ ...buttonStyle, ...style }}
            disabled={disabled}
        >
            {children}
        </Button>
    )
}